// extracted by mini-css-extract-plugin
export default {"popconfirm":"styles_popconfirm__2xm1m","button":"styles_button__N834S","ant-btn-disabled":"styles_ant-btn-disabled__H2tDk","custom-button":"styles_custom-button__pjULC"};